// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1CAjQ","topBottomGutter":"Layout_topBottomGutter__pygWe"};